import { takeLatest, call, put } from 'redux-saga/effects';
import axios from '../axiosConfig';
import { cancelBookingRequest, cancelBookingSuccess } from '../../slices/trip';

const queryString = require('query-string');

function* cancelBookingWorker({ payload: { tripId, tripSegmentId } }) {
  try {
    const url = `trips/cancel?${queryString.stringify(
      {
        tripId,
        tripSegmentId,
      },
      { skipNull: true },
    )}`;
    const config = {
      method: 'get',
      url,
    };
    const { data } = yield call(axios, config);
    if (data) {
      yield put(
        cancelBookingSuccess({
          error: !data.isBookingCancelled && !data.error ? 'Problem in cancel booking' : data.error,
          errorCode: data.errorCode,
          wasVoided: data.wasVoided,
        }),
      );
    } else {
      yield put(cancelBookingSuccess({ error: 'Could not cancel booking' }));
    }
  } catch (error) {
    yield put(cancelBookingSuccess({ error: 'Could not cancel booking' }));
  }
}

function* cancelBookingWatcher() {
  yield takeLatest(cancelBookingRequest.toString(), cancelBookingWorker);
}

export default cancelBookingWatcher;
